import { useEffect } from "react"
import { Emitter } from "@/services/event-emitter"
import { EventTypes } from "@/types/types"

export const useDocumentCursorEmitterEvents = () => {
  useEffect(() => {
    Emitter.on(EventTypes.SET_DOCUMENT_CURSOR, setDocumentCursor)
    Emitter.on(EventTypes.UNSET_DOCUMENT_CURSOR, unsetDocumentCursor)

    return () => {
      Emitter.off(EventTypes.SET_DOCUMENT_CURSOR, setDocumentCursor)
      Emitter.off(EventTypes.UNSET_DOCUMENT_CURSOR, unsetDocumentCursor)
    }
  }, [])

  const setDocumentCursor = (cursor: string) => {
    document.body.style.cursor = cursor
  }

  const unsetDocumentCursor = () => {
    document.body.removeAttribute('style')
  }
}
